<template>
    <div class="container mx-auto px-2 py-4">
    <h1>Impressum</h1>

    </div>
</template>

<script>
import Slider from '@vueform/slider'

export default {
    components: { Slider },
    data: () => ({
        value: 20
    })
}
</script>
